// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SPM0","location":"Header_location__3THjN"};